import settings from './settings/settings.routes';
import conversation from './conversation/conversation.routes';
import { routes as searchRoutes } from '../../modules/search/search.routes';
import { routes as callRoutes } from './calls/routes';
import { routes as contactRoutes } from './contacts/routes';
import { routes as companyRoutes } from './companies/routes';
import { routes as notificationRoutes } from './notifications/routes';
import { routes as inboxRoutes } from './inbox/routes';
import { frontendURL } from '../../helper/URLHelper';
import helpcenterRoutes from './helpcenter/helpcenter.routes';
import campaignsRoutes from './campaigns/campaigns.routes';
import { routes as captainRoutes } from './captain/captain.routes';
import AppContainer from './Dashboard.vue';
import Suspended from './suspended/Index.vue';
import NoAccounts from './noAccounts/Index.vue';
import OnboardingAccountDetails from './onboarding/Index.vue';
import OnboardingInboxSetup from './onboarding/InboxSetup.vue';
import { crmRoutes } from './cw_custom/crm.routes'; // custom: CRM board
import { inicioRoutes } from './cw_custom/inicio.routes'; // custom: Início (home top-level)
import { equipeRoutes } from './cw_custom/equipe.routes'; // custom: Caixa de Entrada (equipe interna)
import { notasRoutes } from './cw_custom/notas.routes'; // custom: aba Notas (bloco pessoal do operador)
import { notificacoesRoutes } from './cw_custom/notificacoes.routes'; // custom: aba Notificações (caixa única)
// custom (2026-08-09): aba Fluxos. SUBSTITUI `triagemRoutes`, removida no mesmo commit —
// aquela reusava o ConversationView do core e prometia uma caixa de atendimento numa tela
// de supervisão. Ver a nota em fluxos.routes.js.
import { fluxosRoutes } from './cw_custom/fluxos.routes';
import { whatsappSaudeRoutes } from './cw_custom/whatsappSaude.routes'; // custom: Saúde do WhatsApp (admin)

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId'),
      component: AppContainer,
      children: [
        ...captainRoutes,
        ...inboxRoutes,
        ...conversation.routes,
        ...settings.routes,
        ...callRoutes,
        ...contactRoutes,
        ...companyRoutes,
        ...searchRoutes,
        ...notificationRoutes,
        ...helpcenterRoutes.routes,
        ...campaignsRoutes.routes,
        ...crmRoutes, // custom: CRM board
        ...inicioRoutes, // custom: Início (home top-level / landing)
        ...equipeRoutes, // custom: Caixa de Entrada (equipe interna)
        ...notasRoutes, // custom: aba Notas (bloco pessoal, flag crm_notas)
        ...notificacoesRoutes, // custom: aba Notificações (flag crm_notificacoes)
        ...fluxosRoutes, // custom: aba Fluxos (flag crm_fluxos, admin-only)
        ...whatsappSaudeRoutes, // custom: Saúde do WhatsApp (admin-only, sem flag)
      ],
    },
    {
      path: frontendURL('accounts/:accountId/onboarding'),
      name: 'onboarding_account_details',
      meta: {
        permissions: ['administrator', 'agent', 'custom_role'],
      },
      component: OnboardingAccountDetails,
    },
    {
      path: frontendURL('accounts/:accountId/onboarding/inbox-setup'),
      name: 'onboarding_inbox_setup',
      meta: {
        permissions: ['administrator', 'agent', 'custom_role'],
      },
      component: OnboardingInboxSetup,
    },
    {
      path: frontendURL('accounts/:accountId/suspended'),
      name: 'account_suspended',
      meta: {
        permissions: ['administrator', 'agent', 'custom_role'],
      },
      component: Suspended,
    },
    {
      path: frontendURL('no-accounts'),
      name: 'no_accounts',
      component: NoAccounts,
    },
  ],
};
